import { render, staticRenderFns } from "./catalogMap.vue?vue&type=template&id=48e40192"
import script from "./catalogMap.vue?vue&type=script&lang=js"
export * from "./catalogMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports